/*
 * @Author: Yun
 * @Date: 2024-02-16 16:28:33
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-05 09:00:29
 */

import React, { useState } from 'react'
import npc from '@images/congress/npc.png'
import cppcc from '@images/congress/cppcc.png'
import img1 from '@images/congress/img1.png'
import img2 from '@images/congress/img2.png'
import img3 from '@images/congress/img3.png'
import img4 from '@images/congress/img4.png'
import txt1 from '@images/congress/txt1.png'
import txt2 from '@images/congress/txt2.png'
import txt3 from '@images/congress/txt3.png'
import txt4 from '@images/congress/txt4.png'
import close from '@icons/close.jpg'
import $ from 'jquery'
import './index.less'

const PREFIX = 'congress-page'

const Congress = (props) => {
    const { id } = props

    const [active, setActive] = useState(false)

    const onImgClick = (e) => {
        $('body').css('overflow', 'hidden')
        setActive(e)
    }

    const onClose = () => {
        $('body').css('overflow', 'auto')
        setActive(false)
    }

    const handleTxt = (e) => {
        if (e) {
            switch (e) {
                case 'img1':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt1`} src={txt1} alt="" />
                case 'img2':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt2`} src={txt2} alt="" />
                case 'img3':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt3`} src={txt3} alt="" />
                case 'img4':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt4`} src={txt4} alt="" />
                default:
                    return ''
            }
        }
    }

    return (
        <section className={PREFIX} id={id}>
            <div className={`${PREFIX}-wrapper`}>
                <img className={`${PREFIX}-img ${PREFIX}-npc`} src={npc} alt="" />
                <img
                    className={`${PREFIX}-img ${PREFIX}-img1`}
                    src={img1}
                    alt=""
                    onClick={() => onImgClick('img1')}
                />
                <img
                    className={`${PREFIX}-img ${PREFIX}-img2`}
                    src={img2}
                    alt=""
                    onClick={() => onImgClick('img2')}
                />
                <img
                    className={`${PREFIX}-img ${PREFIX}-img3`}
                    src={img3}
                    alt=""
                    onClick={() => onImgClick('img3')}
                />
                <img className={`${PREFIX}-img ${PREFIX}-cppcc`} src={cppcc} alt="" />
                <img
                    className={`${PREFIX}-img ${PREFIX}-img4`}
                    src={img4}
                    alt=""
                    onClick={() => onImgClick('img4')}
                />
            </div>
            {active && (
                <div className={`${PREFIX}-txt`}>
                    <div className={`${PREFIX}-cover`}></div>
                    <img className={`${PREFIX}-close`} src={close} alt="" onClick={onClose} />
                    {handleTxt(active)}
                </div>
            )}
        </section>
    )
}

export default Congress
